import { render, staticRenderFns } from "./NoticesAdd.vue?vue&type=template&id=4606f6ab&scoped=true&"
import script from "./NoticesAdd.vue?vue&type=script&lang=js&"
export * from "./NoticesAdd.vue?vue&type=script&lang=js&"
import style0 from "./NoticesAdd.vue?vue&type=style&index=0&id=4606f6ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606f6ab",
  null
  
)

export default component.exports